import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["countDown"],
      _excluded2 = ["time", "text", "isBottom", "dataSource", "value", "setValue", "changeTab", "disabled", "setDisabled", "setOuterTime"];
import React, { useEffect, useState } from 'react';
import { Toast } from 'zarm';
import ConfirmButton from '../confirmButton';
export const countDown = WrapComponent => {
  return props => {
    const {
      countDown: initialCountDown
    } = props,
          otherProps = _objectWithoutProperties(props, _excluded);

    const [_countDown, setCountDown] = useState(initialCountDown);
    useEffect(() => {
      if (_countDown <= 0) return;
      const id = setTimeout(() => {
        setCountDown(c => c - 1);
      }, 1000);
      return () => clearTimeout(id);
    }, [_countDown]);
    return /*#__PURE__*/React.createElement(WrapComponent, _extends({
      time: _countDown
    }, otherProps));
  };
};
export const changeBtnText = WrapComponent => {
  return props => {
    const {
      time,
      text,
      isBottom,
      dataSource,
      value,
      setValue,
      changeTab,
      disabled: superDisabled,
      setDisabled: setSuperDisabled,
      setOuterTime
    } = props,
          otherProps = _objectWithoutProperties(props, _excluded2);

    const [disabled, setDisabled] = useState(true);
    const [finalText, setFinalText] = useState(text);
    useEffect(() => {
      setOuterTime(time);

      if (time <= 0) {
        // 只有一个tab页的时候要滚动到底部 && 鲸小保客户要求
        if (isBottom || (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) > 1) {
          setDisabled(false);
          setFinalText(text);
        } else {
          setDisabled(true);
          setFinalText(text);
        }
      } else if ((dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) === 1) {
        setFinalText(`${text}(${time})秒`);
      } else {
        setDisabled(false);
      }
    }, [isBottom, time]);

    const disabledClick = () => {
      const {
        isBottom: _isBottom
      } = props; // 只有一个tab页的时候要滚动到底部 && 鲸小保客户要求

      if (!_isBottom && (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) === 1) {
        Toast.show('请继续下滑确认全部阅读！');
      }

      if (superDisabled) {
        // 最后一个tab页
        if ((dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) === value + 1 || !disabled) {// TODO
        } else {
          if ((dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) === value + 2) {
            setSuperDisabled(false);
          }

          setValue(value + 1);
          changeTab(value + 1);
        }
      }
    };

    return /*#__PURE__*/React.createElement(WrapComponent, _extends({
      disabled: disabled,
      text: finalText,
      disabledClick: disabledClick
    }, otherProps));
  };
};
export default countDown(changeBtnText(ConfirmButton));